"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var SvgFlexedBicepsFilled = function (props) { return (react_1.default.createElement("svg", __assign({ width: '1em', height: '1em', viewBox: '0 0 24 24' }, props),
    react_1.default.createElement("path", { d: 'M6.792 20.805C4.326 20.355 2 17.921 2 15.615c0-1.916.324-2.69 2.356-7.554.343-.82.734-1.757 1.18-2.835.183-.44.517-.802.942-1.018l3.913-1.99a2.002 2.002 0 012.832 1.229l.768 2.678a1.994 1.994 0 01-1.714 2.53l-1.675.175a.637.637 0 01-.175-1.262l.421-.073a.748.748 0 10-.258-1.473l-1.304.608a.749.749 0 00-.613.625l-.36 2.048c-.023.13-.03.264-.022.397l.272 4.168s1.019-1.312 2.818-1.312c1.8 0 2.668 1.312 2.668 1.312s1.041-1.592 3.264-1.592c2.586 0 4.687 2.214 4.687 4.886S19.805 22 17.099 22L6.792 20.805z' }))); };
exports.default = SvgFlexedBicepsFilled;
//# sourceMappingURL=FlexedBicepsFilled.js.map